module.exports = __webpack_public_path__ + "img/mata-atlantica.cff3e439.png";